import { logError } from 'client/javascript/util/logger';
import { HIDDEN_CLASS } from 'shared/util/constants';

export const DATA_CONDITIONS_TO_SHOW = '[data-conditions-to-show]';
export const GEO_MODULE_SELECTOR = `.${HIDDEN_CLASS}${DATA_CONDITIONS_TO_SHOW}`;

export const getWhitelistedCountries = (countryList = '') => {
  try {
    return JSON.parse(countryList);
  } catch (error) {
    logError(`[Geolocation Based Rendering] getWhitelistedCountries failed: ${error.message}`, error);
    return [];
  }
};

export const isUserCountryInWhitelistedCountriesList = (countryCode, countryList) => {
  try {
    return getWhitelistedCountries(countryList).includes(countryCode);
  } catch (error) {
    logError(`[Geolocation Based Rendering] isUserCountryInWhitelistedCountriesList failed: ${error.message}`, error);
    return false;
  }
};

export const isGeoConfiguredModule = (conditionsToShow = '') => Boolean(conditionsToShow.trim().length);

export const showModule = (nodeReference) => {
  try {
    nodeReference.classList.remove(HIDDEN_CLASS);
  } catch (error) {
    logError(`[Geolocation Based Rendering] showModule failed: ${error.message}`, error);
  }
};
